import React, { useCallback, useState, useEffect, useRef } from "react";
import { Text, Stack, Label, Checkbox, TextField, Toggle, StackItem, Dropdown, IDropdownOption, ColorPicker } from "office-ui-fabric-react";
import { useAuthorizedFetch } from "../../../hooks/useFetch";
import { API_ADMIN_PASSWORD_POLICY, adminUpdatePasswordPolicy } from "../../../api";
import { useFormik } from "formik";
import ButtonPanel from "../../../components/ui/ButtonPanel";
import { PasswordPolicySchema, passwordPolicySchema as schema } from "../../../api/schema";
import { getOptions, saveOption, getTypeList, saveTagItem } from "../../../api";
import { trim } from "lodash";


export interface IOption{
    id: string;
    optionType: string;
    optionValue: string;
    customerId: string
}

export interface ITagInfo{
    editMode: boolean;
}

export interface Props
{
    className?: string;
    style?: React.CSSProperties;
    children?: React.ReactChildren;

    visible?: boolean;
    onDismiss?: () => void;
    onPolicySaved?: () => void;

    tagInfo: ITagInfo;
    onSave?: () => void;

}

export interface ITag {
    id?: number;
    name?: string;
    description?: string;
    active?: boolean;
    type?: number;
}

interface FormProps
{
    initialValues: PasswordPolicySchema;
    onSave: () => void;
    onDismiss?: () => void;
    tagInfo: ITagInfo;
}

export const GroupOptions: IDropdownOption[] = [
    { key: "1", text: 'Global', data : { }},
    { key: '2', text: 'Training', data : { }},
  ];

  export interface ITagType 
  {
      id: string;
      typeName: string;
  }

function TagGroupForm(props: FormProps)
{
    const { initialValues, onSave, onDismiss, tagInfo } = props;
    const [idle, setIdle] = useState<string | undefined>("");
    const [options, setOptions] = useState<IOption[]>();
    const [timeoutEmpty, setTimeoutEmpty] = useState<boolean>(false);
    const [timeoutOption, setTimeoutOption] = useState<IOption | undefined>();
    const [tagType, setTagType] = useState<IDropdownOption[]>([]);
    const [nameField, setNameield] = useState<string>();
    const [descrptionField, setDescrptionField] = useState<string>();
    const [activeCheckBox, setActiveCheckBox] = useState<boolean | undefined>(true);
    const [selectedType, setSelectedType] = useState<number>(0);
    const [tageTypeId, settagTypeId] = useState<string | undefined>();
    const [errorMsg, setErrorMsg] = useState<string>("");
  

    const onChangeField = (e:any, newValue?: string | undefined) => {
        if (e.target.name === "name"){
            setNameield(newValue);
        }
        if (e.target.name === "description"){
            setDescrptionField(newValue);
        }
    }


    const initAlloptions = async (optionJson:IOption[]) => {

        //timeout
        const timeoutOption = optionJson?.find(x => x.optionType.toLowerCase() === 'timeout');
        if (timeoutOption === undefined){
            setTimeoutEmpty(true);
            setIdle("0");
    
            let res = await saveOption({id:'0',optionType:'timeout', optionValue: "0", customerId:'0'});
            if(res.ok)
            {
            }
            else
            {
                console.log("Save weight option error");
            }
    
        }
        else
        {
            if (timeoutOption.optionValue === "")
            {
                setIdle("0");    
            }
            else
            {
                setIdle(JSON.parse(timeoutOption.optionValue));    
            }
        }   
        setTimeoutOption(timeoutOption);
    }

    const createTypeOption = (tagTypeList:ITagType[]) => {
        let tagTypeArr: IDropdownOption[] = [];
        tagTypeList.map((item,index) => {
          tagTypeArr.push({ key: index+1, text: item.typeName, data : {id: item.id}});
        })
        setTagType(tagTypeArr);
      }

    const getOptionsAsync = async () => {
        let res = await getOptions();
        if(res.ok)
        {
            const retValues:IOption[] = await res.json();
            setOptions(retValues);
            initAlloptions(retValues);
        }
        else
        {
            console.log("Error from get options")
        }  
}

    useEffect(() => {
            getOptionsAsync();
     }, []);


     
     const getTypeDataList = async () => {
        const res = await getTypeList();
    
        if(res.ok)
        {
          const retJson:ITagType[] = await res.json();
          createTypeOption(retJson);
        }
        else
        {
        }
      }
    
        // training data list  
        useEffect(() => {
          const callback = async () => {
            getTypeDataList();
        }
          callback();
        }, []);
    
    
    const onChangeActive = (e:any,checked:boolean | undefined) => {
        setActiveCheckBox(checked);
    }

    const onChangeGroup = (id:string |undefined) => {
        if (id !== undefined){
          setSelectedType(parseInt(id));
          const idTagType:IDropdownOption | undefined = tagType.find(x => x.key === parseInt(id));
          settagTypeId(idTagType?.data.id);
        }
      }

      const saveTag = async (saveTags:ITag) => {
    
        const res = await saveTagItem(saveTags);
        if(res.ok)
        {
          const retJson:string = await res.json();
        }
        else
        {
        }
      }


      const onSaveTag = async () => {
//        alert(nameField.current + "," + descrptionField.current + "," + activeCheckBox + "," + tageTypeId);
        let err = "";


        if (nameField === undefined || nameField?.trim() === "") {
            err = "Name can't be empty";
        }
        else if (isNaN(tageTypeId as any)){    
            err = "Please choose a group";
        }

        setErrorMsg(err);
        const tag:ITag = {name:nameField, description:descrptionField, active:activeCheckBox,type:parseInt(tageTypeId!)};
        if (err === ""){        
            await saveTag(tag);
            props.onSave();
        }
      }


    return (            
        <ButtonPanel
            headerText={tagInfo.editMode === true ? "Edit tag" : "Add tag"}
            onDismiss={onDismiss}
            onPrimaryButtonClick={() => onSaveTag()}
            isOpen
        >


<Stack tokens={{ childrenGap: "l1" }} style={{ marginTop: 8 }}>
                <StackItem>
                    <div style={{color:"red"}}>{errorMsg}</div>
                </StackItem>
                <StackItem>
                    <TextField label="Name" onChange={onChangeField} name="name" value={nameField} errorMessage={""} />
                </StackItem>
                <StackItem>
                    <TextField label="Description" onChange={onChangeField} name="description" value={descrptionField} errorMessage={""} />
                </StackItem>
                <StackItem>
                    <Checkbox label="Active" checked={activeCheckBox} onChange={(e, check) => onChangeActive(e, check)} />
                </StackItem>
                <StackItem>
                    <Dropdown label="Group" placeholder="Select a group" style={{width: "200px" }}  onChange={(_, option) => onChangeGroup(option?.key.toString())} options={tagType}></Dropdown>
                </StackItem>
            </Stack>
        </ButtonPanel>
    );
}

function AddGroupPanel(props: Props)
{
    const { onDismiss, onPolicySaved, visible } = props;
    const [state, policy, refresh] = useAuthorizedFetch<PasswordPolicySchema>(API_ADMIN_PASSWORD_POLICY);

    const onSave = () => {
        props.onSave!();
    };

    return (visible && state === "success" && policy) ? (
        <TagGroupForm onDismiss={onDismiss} onSave={onSave} initialValues={policy} tagInfo={props.tagInfo}/>
    ) : null
}

export default AddGroupPanel;